// extracted by mini-css-extract-plugin
export default {"search_box":"index_search_box_5BePE","text":"index_text_gQaDC","btn":"index_btn_Qns-j","search":"index_search_6PKgd"};